<div class="background">
	<div class="container">
		<h1 class="heading1 mb-3">404</h1>
		<p class="paragraph mb-4">
			Faqja që ju po kërkoni nuk ekziston. Provoni përsëri ose kthehuni në faqen
			kryesore.
		</p>
		<button class="blue-button mb-5" routerLink="/">
			Kthehu në faqen kryesore
		</button>
	</div>
</div>
